import React from 'react';
import PropTypes from 'prop-types';

import './PublicMenu.scss';

const PublicMenu = ({ hideSignIn, signInPath }) => (
	<div id="public-menu">
		<div>
			<img
				id="rollkall-logo"
				src="/images/logo.png"
				alt="RollKall logo"
			/>
			<span className="hidden-xs">Connecting You with Everyday Heroes</span>
		</div>
		<If condition={!hideSignIn}>
			<div>
				<span className="hidden-xs">Already a member?</span>
				<a id="btn-sign-in" href={signInPath}>Sign In</a>
			</div>
		</If>
	</div>
);

PublicMenu.propTypes = {
	hideSignIn : PropTypes.bool,
	signInPath : PropTypes.string,
};

PublicMenu.defaultProps = {
	hideSignIn : false,
	signInPath : '/login',
};

export default PublicMenu;
